import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
interface MarqueeBannerProps {
  texts: string[];
  direction?: 'left' | 'right';
  speed?: number;
  dotColor?: string;
  textColor?: string;
  bgFrom?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export const MarqueeBanner = ({
  texts,
  direction = 'left',
  speed = 20,
  dotColor = 'bg-brand-red/20',
  textColor = 'text-white/[0.03]',
  bgFrom = 'from-brand-black',
  size = 'lg',
  className = ''
}: MarqueeBannerProps) => {
  const sizeClasses = {
    sm: 'text-3xl md:text-5xl',
    md: 'text-5xl md:text-7xl',
    lg: 'text-6xl md:text-8xl'
  };
  const xStart = direction === 'left' ? 0 : -1200;
  const xEnd = direction === 'left' ? -1200 : 0;
  return <div className={`overflow-hidden relative py-4 ${className}`} data-id="element-568">
      <div className={`absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r ${bgFrom} to-transparent z-10`} data-id="element-569" />
      <div className={`absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l ${bgFrom} to-transparent z-10`} data-id="element-570" />
      <motion.div animate={{
      x: [xStart, xEnd]
    }} transition={{
      duration: speed,
      repeat: Infinity,
      ease: 'linear'
    }} className="flex gap-8 items-center whitespace-nowrap" data-id="element-571">
        {[...Array(5)].map((_, setIdx) => <Fragment key={setIdx} data-id="element-572">
            {texts.map((text, textIdx) => <Fragment key={`${setIdx}-${textIdx}`} data-id="element-573">
                <span className={`font-oswald ${sizeClasses[size]} font-bold ${textColor} uppercase select-none`} data-id="element-574">
                  {text}
                </span>
                <span className={`w-3 h-3 rounded-full ${dotColor} flex-shrink-0`} data-id="element-575" />
              </Fragment>)}
          </Fragment>)}
      </motion.div>
    </div>;
};